// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2KTMP","savePackageButton":"ClientWallet_savePackageButton__2oMkT"};